var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUploadSuccessfulIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 153.001,
    height: 86.792,
    viewBox: "0 0 153.001 86.792",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Done",
    transform: "translate(-17 -43.75)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2296",
    "data-name": "Path 2296",
    d: "M49.584,113.584h64.459a5,5,0,0,0,1.063-.114,5,5,0,0,0,1.063.114H153a4.958,4.958,0,1,0,0-9.917h-4.25a4.958,4.958,0,0,1,0-9.917h13.458a4.958,4.958,0,1,0,0-9.917H146.626a4.958,4.958,0,1,0,0-9.917H101.292a4.958,4.958,0,1,0,0-9.917H60.917a4.958,4.958,0,0,0,0,9.917H32.583a4.958,4.958,0,0,0,0,9.917H50.292a4.958,4.958,0,1,1,0,9.917H21.958a4.958,4.958,0,1,0,0,9.917H49.584a4.958,4.958,0,1,0,0,9.917Zm115.459,0a4.958,4.958,0,1,0-4.958-4.958A4.958,4.958,0,0,0,165.043,113.584Z",
    transform: "translate(0 -5.542)",
    fill: "#f3f7ff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2297",
    "data-name": "Path 2297",
    d: "M172.5,45v4.25",
    transform: "translate(-45.353)",
    fill: "none",
    stroke: "#75a4fe",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2298",
    "data-name": "Path 2298",
    d: "M172.5,59v4.25",
    transform: "translate(-45.353 -4.083)",
    fill: "none",
    stroke: "#75a4fe",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2299",
    "data-name": "Path 2299",
    d: "M162.5,55h4.25",
    transform: "translate(-42.437 -2.917)",
    fill: "none",
    stroke: "#75a4fe",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2300",
    "data-name": "Path 2300",
    d: "M176.5,55h4.25",
    transform: "translate(-46.52 -2.917)",
    fill: "none",
    stroke: "#75a4fe",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2301",
    "data-name": "Path 2301",
    d: "M89.5,148v2.833",
    transform: "translate(-21.145 -30.041)",
    fill: "none",
    stroke: "#75a4fe",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2302",
    "data-name": "Path 2302",
    d: "M89.5,160v2.833",
    transform: "translate(-21.145 -33.541)",
    fill: "none",
    stroke: "#75a4fe",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2303",
    "data-name": "Path 2303",
    d: "M81.5,156h2.833",
    transform: "translate(-18.812 -32.374)",
    fill: "none",
    stroke: "#75a4fe",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2304",
    "data-name": "Path 2304",
    d: "M93.5,156h2.833",
    transform: "translate(-22.312 -32.374)",
    fill: "none",
    stroke: "#75a4fe",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2305",
    "data-name": "Path 2305",
    d: "M136.879,109.215A32.233,32.233,0,0,0,143.27,96.3,32.7,32.7,0,0,0,103.722,56.93a32.4,32.4,0,0,0-24.13,25.342,32.694,32.694,0,0,0,35.154,38.754,32.388,32.388,0,0,0,12.676-3.9",
    transform: "translate(-18.083 -3.208)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2306",
    "data-name": "Path 2306",
    d: "M136.879,109.215A32.233,32.233,0,0,0,143.27,96.3,32.7,32.7,0,0,0,103.722,56.93a32.4,32.4,0,0,0-24.13,25.342,32.694,32.694,0,0,0,35.154,38.754,32.388,32.388,0,0,0,12.676-3.9",
    transform: "translate(-18.083 -3.208)",
    fill: "none",
    stroke: "#1f64e7",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2307",
    "data-name": "Path 2307",
    d: "M150.7,138.6a25.972,25.972,0,0,0,5.08-4.312Z",
    transform: "translate(-38.995 -26.043)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2308",
    "data-name": "Path 2308",
    d: "M150.7,138.6a25.972,25.972,0,0,0,5.08-4.312",
    transform: "translate(-38.995 -26.043)",
    fill: "none",
    stroke: "#1f64e7",
    strokeLinecap: "round",
    strokeWidth: 2.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2309",
    "data-name": "Path 2309",
    d: "M142.5,91.6q-.3.005-.609.006A33.918,33.918,0,0,1,108.129,60,29.922,29.922,0,1,0,142.5,91.6Z",
    transform: "translate(-19.25 -4.375)",
    fill: "#e8f0fe"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2310",
    "data-name": "Path 2310",
    d: "M107.558,96.764a2.108,2.108,0,0,0-3,.137,2.164,2.164,0,0,0,.136,3.035l10,9.235a2.952,2.952,0,0,0,4.2-.192c.047-.052.047-.052.091-.106l14.272-17.352a2.164,2.164,0,0,0-.276-3.025,2.109,2.109,0,0,0-2.993.278l-13.418,16.314Z",
    transform: "translate(-25.375 -12.541)",
    fill: "#fff",
    stroke: "#1f64e7",
    strokeLinecap: "round",
    strokeWidth: 2.5,
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2311",
    "data-name": "Path 2311",
    d: "M104.258,64.413a28.254,28.254,0,0,0-9.728,6.157,28.7,28.7,0,0,0-2.022,2.165m-1.948,2.6q-.751,1.135-1.382,2.323-.466.877-.867,1.779",
    transform: "translate(-20.799 -5.662)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2312",
    "data-name": "Path 2312",
    d: "M104.2,64.877a.885.885,0,0,0-.622-1.658Zm-4.346,1.06.438.77Zm-5.694,4.267-.615-.637Zm-2.7,1.595a.885.885,0,0,0,1.355,1.14Zm-.532,3.663a.885.885,0,1,0-1.477-.977ZM88.813,77.3l.782.416h0Zm-1.676,1.419a.885.885,0,1,0,1.618.719Zm16.445-15.5a29.062,29.062,0,0,0-4.161,1.949l.876,1.539a27.3,27.3,0,0,1,3.908-1.83Zm-4.161,1.949a29.3,29.3,0,0,0-5.871,4.4l1.23,1.274a27.54,27.54,0,0,1,5.516-4.135Zm-5.871,4.4A29.576,29.576,0,0,0,91.465,71.8l1.355,1.14a27.8,27.8,0,0,1,1.96-2.1Zm-4.093,4.918q-.774,1.17-1.425,2.4l1.564.831q.611-1.15,1.338-2.25Zm-1.425,2.4q-.481.9-.894,1.834l1.618.719q.388-.873.84-1.723Z",
    transform: "translate(-20.434 -5.297)",
    fill: "#75a4fe"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadSuccessfulIcon);
export default __webpack_public_path__ + "static/media/upload-successful-icon.55170882fb7bf7897757b2b2209aa570.svg";
export { ForwardRef as ReactComponent };